export const quizData = [
    {
        question: 'Combien de temps faut-il en\nmoyenne pour développer un\nvaccin\u00A0?',
        options: ['Environ 6 mois', 'Environ 1 an', 'Environ 10 ans'],
        answer: 'Environ 10 ans',
        debriefCorrect: 'Bonne réponse !',
        illustrationQuestion: 'histoire-1/q1',
        illustrationDebrief: 'histoire-1/r1',
        debrief:
            'Développer un vaccin est un processus <span class="bold">long et rigoureux</span>. Il faut en moyenne <span class="bold">10 ans</span> pour concevoir, tester et valider un vaccin.<br /><br />Cela inclut la recherche en laboratoire, les essais cliniques (en trois phases), la validation réglementaire et la production.',
    },
    {
        question: 'Combien de vaccins hexavalents sont recommandés par la HAS en France ?',
        options: ['1', '2', '3'],
        answer: '3',
        debriefCorrect: 'Bonne réponse !',
        illustrationQuestion: 'histoire-1/q2',
        illustrationDebrief: 'histoire-1/r2',
        debrief:
            'Trois vaccins hexavalents sont recommandés par la HAS en France.<br /><br />Tous protègent contre six maladies (diphtérie, tétanos, coqueluche, poliomyélite, Hib et hépatite B), mais leur composition varie selon le laboratoire.',
    },
    {
        question:
            "Quelles sont les 2 protéines produites dans la grande majorité des isolats analysés au moment de l'enquête ?",
        options: [
            'TCT (cytotoxine trachéale) et PT (toxine pertussique)',
            'PRN (pertactine) et FIM2 (fimbriae de type 2)',
            'PRN (pertactine) et TDN (toxine dermonécrotique)',
        ],
        answer: 'PRN (pertactine) et FIM2 (fimbriae de type 2)',
        debriefCorrect: 'Bonne réponse !',
        illustrationQuestion: 'histoire-1/q3',
        illustrationDebrief: 'histoire-1/r3',
        debrief:
            'Avant l\'enquête, la plupart des bactéries ne produisaient pas la protéine PRN. Au moment de l\'enquête, c\'est l\'inverse : presque toutes l\'expriment.. <span class="card">Retournez la carte <span class="bold bold-blue">60</span></span> </br><span class="card2">Défaussez les cartes</br><span class="bold bold-blue">10, 45, 64</span></span>',
    },
];
